import React from 'react'
import { AutoColumn } from '../../components/Column'
import styled from 'styled-components'
import { TYPE, ExternalLink } from '../../theme'
import { RowBetween, RowFixed } from '../../components/Row'
import { Link } from 'react-router-dom'
import { ProposalStatus } from './styled'
import { ButtonPrimary } from '../../components/Button'

import { Button } from 'rebass/styled-components'
import { darken } from 'polished'
import { CardSection, DataCard, CardNoise, CardBGImage } from '../../components/earn/styled'
import { ProposalData, useUserVotes, useDeerUserDelegatee, useAllProposalData } from '../../state/governance/hooks'
import DelegateModal from '../../components/deerVote/DelegateModal'
import { useTokenBalance } from '../../state/wallet/hooks'
import { useActiveWeb3React } from '../../hooks'
import { DEER, ZERO_ADDRESS } from '../../constants'
import { JSBI, TokenAmount, ChainId } from '@uniswap/sdk'
import { shortenAddress, getEtherscanLink, geGovContract, calculateGasMargin } from '../../utils'
import Loader from '../../components/Loader'
import FormattedCurrencyAmount from '../../components/FormattedCurrencyAmount'
import { useModalOpen, useToggleDelegateModal } from '../../state/application/hooks'
import { ApplicationModal } from '../../state/application/actions'
import { TransactionResponse } from '@ethersproject/providers'
import { BigNumber } from '@ethersproject/bignumber'

const PageWrapper = styled(AutoColumn)``

const TopSection = styled(AutoColumn)`
  max-width: 640px;
  width: 100%;
`

const Proposal = styled(Button)`
  padding: 0.75rem 1rem;
  width: 100%;
  margin-top: 1rem;
  border-radius: 12px;
  display: grid;
  grid-template-columns: 48px 1fr 120px;
  align-items: center;
  text-align: left;
  outline: none;
  cursor: pointer;
  color: ${({ theme }) => theme.text1};
  text-decoration: none;
  background-color: ${({ theme }) => theme.bg1};
  &:focus {
    background-color: ${({ theme }) => darken(0.05, theme.bg1)};
  }
  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.bg1)};
  }
`

const ProposalNumber = styled.span`
  opacity: 0.6;
`

const ProposalTitle = styled.span`
  font-weight: 600;
`

const VoteCard = styled(DataCard)`
  background: radial-gradient(76.02% 75.41% at 1.84% 0%, #27ae60 0%, #000000 100%);
  overflow: hidden;
`

const WrapSmall = styled(RowBetween)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: wrap;
  
  `};
`

const TextButton = styled(TYPE.main)`
  color: ${({ theme }) => theme.primary1};
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

const AddressButton = styled.div`
  border: 1px solid ${({ theme }) => theme.bg3};
  padding: 2px 4px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledExternalLink = styled(ExternalLink)`
  color: ${({ theme }) => theme.text1};
`

const EmptyProposals = styled.div`
  border: 1px solid ${({ theme }) => theme.text4};
  padding: 16px 12px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export default function DeerVote() {
  const { account, chainId, library } = useActiveWeb3React()

  // toggle for showing delegation modal
  const showDelegateModal = useModalOpen(ApplicationModal.DELEGATE)
  const toggleDelegateModal = useToggleDelegateModal()

  // get data to list all proposals
  const allProposals: ProposalData[] = useAllProposalData()

  // user data
  const availableVotes: TokenAmount | undefined = useUserVotes()
  const deerBalance: TokenAmount | undefined = useTokenBalance(account ?? undefined, chainId ? DEER[chainId] : undefined)
  const userDelegatee: string | undefined = useDeerUserDelegatee()

  // show delegation option if they have have a balance, but have not delegated
  const showUnlockVoting = Boolean(
    deerBalance && JSBI.notEqual(deerBalance.raw, JSBI.BigInt(0)) && userDelegatee === ZERO_ADDRESS
  )

  async function createPropose() {
    if (!chainId || !library || !account) return
  
    const govContract = geGovContract(chainId, library, account)
    const estimate = govContract.estimateGas.propose
    const method: (...args: any) => Promise<TransactionResponse> = govContract.propose

//     const reduceUni = 
//     `# Reduce UNI Governance Proposal & Quorum Thresholds

// Uniswap's governance system currently has high thresholds for proposal submission and quorum relative to total delegated UNI. Since the launch of the governance system, there have been [discussions](https://gov.uniswap.org/t/proposal-reduce-amount-of-unis-required-to-submit-governance-proposal/3320) on [lowering these thresholds](https://gov.uniswap.org/t/proposal-reduce-amount-of-unis-required-to-submit-governance-proposal/3320/29) to make governance more accessible.

// Having followed these discussions from the beginning, Dharma has prepared a proposal that we think achieves the goal of making governance more accessible, while still ensuring that Uniswap governance is not subject to unilateral deleterious actors.  _We propose a threshold of 3m UNI for proposal submission, and 30m UNI as quorum._

// In order to achieve this reduction in thresholds, a new \`GovernorAlpha\` contract is required. To that end, we have [deployed a new contract](https://etherscan.io/address/0xeca491e162d157760f167c4dd92b45ae6e5cf0f1#code) which contains the following changes:
// - \`quorumVotes\` has been changed from \`40_000_000e18\` to \`30_000_000e18\`, i.e. from 4% to 3%.
// - \`proposalThreshold\` has been modified from \`10_000_000e18\` to \`3_000_000e18\`, i.e. from 1% to 0.3%.
// - a public \`__acceptAdmin()\` function has been added, allowing the contract to claim ownership over the \`Timelock\` contract once \`setPendingAdmin\` has been executed.
// - \`timelock\` and \`uni\` are now declared as \`constant\` instead of via assignment to storage slots during contract construction, as their values are not modifiable after deployment (and use of \`immutable\` would necessitate a major Solidity version bump and corresponding refactor of already well-audited code).

// We believe this proposal will help foster a vibrant Uniswap governance process, and we are excited to participate in these governance decisions.`

//     const retroactiveAirdropDescription = 
//     `# Retroactive Proxy Contract Airdrop — Phase One

// ## Context

// - Why: [Retroactive Airdrop Excludes Proxy Contract Users)](https://gov.uniswap.org/t/retroactive-airdrop-excludes-proxy-contract-users-e-g-dharma-matcha-etc/1222)
// - How: [Application For Retroactive Proxy Contract Airdrop [For Projects / Apps]](https://gov.uniswap.org/t/application-for-retroactive-proxy-contract-airdrop-for-projects-apps/3221)
// - Phase 1 Details: [[Proposal] Excluded Proxy Contract Airdrop — Phase 1](https://gov.uniswap.org/t/proposal-excluded-proxy-contract-airdrop-phase-1/)
// - Intention-to-Submit Announcement: [Announcing Dharma’s Intention to Propose the Retroactive UNI Distribution](https://gov.uniswap.org/t/announcing-dharmas-intention-to-propose-the-retroactive-uni-distribution/7450)
// - Code: [https://github.com/dharmaprotocol/excluded-uni-airdrop-users](https://github.com/dharmaprotocol/excluded-uni-airdrop-users)
// - Contract: [RetroactiveMerkleDistributorPhaseOne](https://etherscan.io/address/0x967f2c0826af779a09e42eff7bfadad7618b55e5#code)
// - Merkle Root and claims: [phase-one-merkle-root-and-claims.json](https://raw.githubusercontent.com/dharmaprotocol/excluded-uni-airdrop-users/master/merkle-roots-and-claims/phase-one-merkle-root-and-claims.json)

// ## Description

// This proposal brings to a formal vote the Retroactive Distribution, discussed at length in the above links.

// This proposal retroactively distributes 400 UNI to 12,619 distinct addresses who interacted with Uniswap via a proxy contract. These 12,619 users are "Phase 1" of the Retroactive Distribution, encompassing users of application-integrations. All of these 12,619 addresses were excluded from the original airdrop.

// The Phase determination was made based on how easy it is to programmatically hook a trading bot into them, as this is a proxy for what portion of these cohorts risk representing multiple addresses per end-user. Phase 1 is the less programmatically accessible cohort, indicating a lower likelihood of multiple addresses per end-user.

// Specifically, this proposal transfers 5,047,600 UNI to a new MerkleDistributor contract, which will then allow for 400 UNI to be claimed by each of the 12,619 accounts held by users of the following projects:

// | Project    | Accounts | % of total |
// |------------|----------|------------|
// | Argent     | 3418     | 27.09%     |
// | DeFi Saver | 890      | 7.05%      |
// | Dharma     | 2833     | 22.45%     |
// | eidoo      | 301      | 2.39%      |
// | FURUCOMBO  | 57       | 0.45%      |
// | MEW        | 4278     | 33.90%     |
// | Monolith   | 19       | 0.15%      |
// | Nuo        | 740      | 5.86%      |
// | Opyn       | 79       | 0.63%      |
// | rebalance  | 4        | 0.03%      |

// ## Additional Considerations

// ### 1. No Repeat Retroactive Airdrop Proposals

// Dharma is committed to carrying out the Retroactive Airdrop proposal. This includes proposing Phase 1, and, if Phase 1 passes, proposing Phase 2.

// If either Phase fails, we will accept that as the final determination of the Uniswap community. Should both Phases pass, we will not vote in favor of any further retroactive airdops.

// ### 2. Dharma's Commitment to Uniswap Governance

// Dharma is committed to being an active, engaged member of Uniswap governance, just as we have been in the Compound community.

// As a signal of this commitment, if this proposal passes, we will commit to:
// - Giving Dharma users the ability to delegate their UNI holdings for voting, as well as to vote directly with their UNI holdings.
// - Participating in the development of a Uniswap Improvement Proposal (UIP) Process in collaboration with other engaged community members.`

const deerfiGrants = `# Deerfi Grants Program v0.1

*co-authored with [Ken Ng](https://twitter.com/nkennethk?lang=en)*

## Summary:

**This post outlines a framework for funding Uniswap ecosystem development with grants from the[ UNI Community Treasury](https://uniswap.org/blog/uni/).** The program starts small—sponsoring hackathons, [for example](https://gov.uniswap.org/c/proposal-discussion/5)—but could grow in significance over time (with renewals approved by governance) to fund core protocol development. Grants administration is a subjective process that cannot be easily automated, and thus we propose a nimble committee of 6 members —1 lead and 5 reviewers—to deliver an efficient, predictable process to applicants, such that funding can be administered without having to put each application to a vote. We propose the program start with an initial cap of $750K per quarter and a limit of 2 quarters before renewal—a sum that we feel is appropriate for an MVP relative to the size of the treasury that UNI token holders are entrusted with allocating.

**Purpose:**

**The mission of the UGP is to provide valuable resources to help grow the Uniswap ecosystem.** Through public discourse and inbound applications, the community will get first-hand exposure to identify and respond to the most pressing needs of the ecosystem, as well as the ability to support innovative projects expanding the capabilities of Uniswap. By rewarding talent early with developer incentives, bounties, and infrastructure support, UGP acts as a catalyst for growth and helps to maintain Uniswap as a nexus for DeFi on Ethereum.

**Quarterly Budget:**

* Max quarterly budget of up to $750k
* Budget and caps to be assessed every six months

**Grant Allocation Committee:**

* Of 6 committee members: 1 lead and 5 reviewers
* Each committee has a term of 2 quarters (6 months) after which the program needs to be renewed by UNI governance
* Committee functions as a 4 of 5 multi-sig

**Committee Members**

While the goals and priorities of the grant program will be thoroughly discussed and reviewed by the community through public discourse, **the decision to start UGP by operating as a small committee is to ensure that the application and decision process will be efficient and predictable, so applicants have clear objectives and timely decisions.**

Starting with just six members enables the committee to efficiently fund projects with tight feedback loops and rapid iterations. The purpose of this committee would be to test the hypothesis that the Grants Program can successfully provide value for the UNI ecosystem before scaling the program.

**We suggest the grants program is administered by a single lead. Here we propose Kenneth Ng, a co-author of this post**. Ken has helped grow the Ethereum Foundation Grants Program over the last two years in establishing high level priorities and adapting for the ecosystems needs.

**The other 5 committee members should be thought of as “reviewers” — UNI community members who will keep the grants program functional by ensuring Ken is leading effectively and, of course, not absconding with funds.** Part of the reviewers job is to hold the program accountable for success (defined below) and/or return any excess funds to the UNI treasury. Reviewers are not compensated as part of this proposal as we expect their time commitment to be minimal. Compensation for the lead role is discussed below, as we expect this to be a labor intensive role.

**Program Lead:** [Ken Ng](https://twitter.com/nkennethk?lang=en) (HL Creative Corp)
*Ecosystem Support Program at the Ethereum Foundation*

1. Reviewer: [Jesse Walden](https://twitter.com/jessewldn) (o/b/o Unofficial LLC dba [Variant Fund](http://twitter.com/variantfund))
*Founder and Investor at Variant Fund (holds UNI)*

2. Reviewer: [Monet Supply](https://twitter.com/MonetSupply)
*Risk Analyst at MakerDAO*

3. Reviewer: [Robert Leshner](https://twitter.com/rleshner)
*Founder and CEO of Compound Finance*

4. Reviewer: [Kain Warwick](https://twitter.com/kaiynne)
*Founder of Synthetix*

5. Reviewer: [Ashleigh Schap](https://twitter.com/ashleighschap)
*Growth Lead, Uniswap (Company)*

## Methodology

**1.1 Budget**

This proposal recommends a max cap of $750K per quarter, with the ability to reevaluate biannually at each epoch (two fiscal quarters). While the UGP Grants Committee will be the decision makers around individual grants, respective budgets, roadmaps, and milestones, any top-level changes to UGP including epochs and max cap, will require full community quorum (4% approval).

The UGP will be funded by the UNI treasury according to the[ release schedule](https://uniswap.org/blog/uni/) set out by the Uniswap team, whereby 43% of the UNI treasury is released over a four-year timeline. In Year 1 this will total to 172,000,000 UNI (~$344M as of writing).

Taking into consideration the current landscape of ecosystem funding across Ethereum, the community would be hard-pressed to allocate even 5% of Year 1’s treasury. For context Gitcoin CLR Round 7 distributed $725k ($450k in matched) across 857 projects and YTD, Moloch has granted just under $200k but in contrast, the EF has committed to somewhere in the 8 figure range.

**1.2 Committee Compensation**

Operating a successful grants program takes considerable time and effort. Take, for instance, the EF Ecosystem Support Program, which has awarded grants since 2018, consists of an internal team at the Foundation as well as an ever increasing roster of community advisors in order to keep expanding and adapting to best serve the needs of the Ethereum ecosystem. While the structure of the allocation committee has six members, we propose that only the lead will be remunerated for their work in establishing the initial processes, vetting applications, and managing the program overall as this role is expected to be time consuming if the program is to be succesful. We propose that the other committee members be unpaid UNI ecosystem stakeholders who have an interest in seeing the protocol ecosystem continue to operate and grow.

**We propose the lead be compensated 25 UNI/hr (approximately $100 USD at time of this writing) capped at 30 hours/week. This compensation, along with the quarterly budget, will be allocated to the UGP multisig from the UNI treasury**. In keeping with the committee’s commitment to the community, hours and duties will be logged publicly and transparently .

**2.1 Priorities**

Initially, the program aims to start narrow in scope, funding peripheral ecosystem initiatives, such as targeted bounties, hackathon sponsorships, and other low-stakes means of building out the Uniswap developer ecosystem. Over time, if the program proves effective, the grant allocations can grow in scope to include, for example, improved frontends, trading interfaces, and eventually, core protocol development.

![|624x199](upload://vNP0APCOjiwQMurCmYI47cTLklc.png)

With the initial priorities in mind, some effective measures for quick successes might look like:

* Total number of projects funded
* Quarterly increase in applications
* Project engagement post-event/funding
* Overall community engagement/sentiment

**2.2 Timeline**

In keeping with the fast pace of the UNI ecosystem, we organize time in epochs, or two calendar quarters. Each epoch will see two funding rounds, one per quarter, after which the community can review and create proposals to improve or revamp the program as they deem fit.

**![|624x245](upload://n56TSh5X3mt4TSqVVMFhbnZM0eM.png)**

**Rolling Wave 1 & 2 Applications**

* Starting in Q1 2021, UGP will start accepting applications for events looking for support in the form of bounties or prizes that in parallel can be proactively sourced. During these first two waves of funding projects, the allocation committee lead can begin laying out guardrails for continued funding

* Considering the immediate feedback loops for the first epoch, we expect these allocation decisions to be discussed and reviewed by the larger community. Should this not be of value, the community can submit a formal governance proposal to change any piece of UGP that was not effective

**Wave 3 & Beyond**

* Beginning with Wave 3, there should have been enough time with impactful projects funded to be considered for follow-on funding, should it make sense. In the same vein, projects within scope will be expanded to also include those working on integrations and and other key components.

* Beyond the second epoch, as the community helps to review and help adapt UGP to be most effective, the scope will continue to grow in order to accommodate the state of the ecosystem including that of core protocol improvements

## Conclusion:

**If this proposal is successfully approved, UGP will start accepting applications on a rolling basis beginning at the start of 2021.** With the phases and priorities laid out above, UGP will aim to make a significant impact by catalyzing growth and innovation in the UNI ecosystem.

**This program is meant to be the simplest possible MVP of a Uniswap Ecosystem Grants initiative.** While the multi-sig committee comes with trust assumptions about the members, our hope is the community will approve this limited engagement to get the ball rolling in an efficient structure. **After the first epoch (2 fiscal quarters) the burden of proof will be on UGP to show empirical evidence that the program is worth continuing in its existing form and will submit to governance to renew treasury funding.**

If this program proves successful, we hope it will inspire others to follow suit and create their own funding committees for allocating treasury capital—ideally with different specializations.`

    const args = [
      ['0xbed87AdAcc517EbC5a6aa321a5afA3532f16380a'],
      [BigNumber.from(0)],
      ['transfer(address,uint256)'],
      ['0x000000000000000000000000e501d72935f88bfd6a30d7bb0787b9b815e693700000000000000000000000000000000000000000000000241a9b4f617a280000'],
      deerfiGrants
    ]
    const value = null
  
    await estimate(...args)
    .then(estimatedGasLimit =>
      method(...args, {
        ...(value ? { value } : {}),
        gasLimit: calculateGasMargin(estimatedGasLimit)
      }).then(response => {
        console.log(response, 'response')
      })
    )
    .catch(error => {
      // we only care if the error is something _other_ than the user rejected the tx
      if (error?.code !== 4001) {
        console.error(error)
      }
    })
  }

  return (
    <PageWrapper gap="lg" justify="center">
      <DelegateModal
        isOpen={showDelegateModal}
        onDismiss={toggleDelegateModal}
        title={showUnlockVoting ? 'Unlock Votes' : 'Update Delegation'}
      />
      <TopSection gap="md">
        <VoteCard>
          <CardBGImage />
          <CardNoise />
          <CardSection>
            <AutoColumn gap="md">
              <RowBetween>
                <TYPE.white fontWeight={600}>Deerfi Governance</TYPE.white>
              </RowBetween>
              <RowBetween>
                <TYPE.white fontSize={14}>
                  DEER tokens represent voting shares in Deerfi governance. You can vote on each proposal yourself or
                  delegate your votes to a third party.
                </TYPE.white>
              </RowBetween>
            </AutoColumn>
          </CardSection>
          <CardBGImage />
          <CardNoise />
        </VoteCard>
      </TopSection>
      <TopSection gap="2px">
        <WrapSmall>
          <TYPE.mediumHeader style={{ margin: '0.5rem 0.5rem 0.5rem 0', flexShrink: 0 }}>Proposals</TYPE.mediumHeader>
          <ButtonPrimary
              style={{ width: 'fit-content' }}
              padding="8px"
              borderRadius="8px"
              onClick={createPropose}
            >
          </ButtonPrimary>
          {(!allProposals || allProposals.length === 0) && !availableVotes && <Loader />}
          {showUnlockVoting ? (
            <ButtonPrimary
              style={{ width: 'fit-content' }}
              padding="8px"
              borderRadius="8px"
              onClick={toggleDelegateModal}
            >
              Unlock Voting
            </ButtonPrimary>
          ) : availableVotes && JSBI.notEqual(JSBI.BigInt(0), availableVotes?.raw) ? (
            <TYPE.body fontWeight={500} mr="6px">
              <FormattedCurrencyAmount currencyAmount={availableVotes} /> Votes
            </TYPE.body>
          ) : deerBalance &&
            userDelegatee &&
            userDelegatee !== ZERO_ADDRESS &&
            JSBI.notEqual(JSBI.BigInt(0), deerBalance?.raw) ? (
            <TYPE.body fontWeight={500} mr="6px">
              <FormattedCurrencyAmount currencyAmount={deerBalance} /> Votes
            </TYPE.body>
          ) : (
            ''
          )}
        </WrapSmall>
        {!showUnlockVoting && (
          <RowBetween>
            <div />
            {userDelegatee && userDelegatee !== ZERO_ADDRESS ? (
              <RowFixed>
                <TYPE.body fontWeight={500} mr="4px">
                  Delegated to:
                </TYPE.body>
                <AddressButton>
                  <StyledExternalLink
                    href={getEtherscanLink(ChainId.MAINNET, userDelegatee, 'address')}
                    style={{ margin: '0 4px' }}
                  >
                    {userDelegatee === account ? 'Self' : shortenAddress(userDelegatee)}
                  </StyledExternalLink>
                  <TextButton onClick={toggleDelegateModal} style={{ marginLeft: '4px' }}>
                    (edit)
                  </TextButton>
                </AddressButton>
              </RowFixed>
            ) : (
              ''
            )}
          </RowBetween>
        )}
        {allProposals?.length === 0 && (
          <EmptyProposals>
            <TYPE.body style={{ marginBottom: '8px' }}>No proposals found.</TYPE.body>
            <TYPE.subHeader>
              <i>Proposals submitted by community members will appear here.</i>
            </TYPE.subHeader>
          </EmptyProposals>
        )}
        {allProposals?.map((p: ProposalData, i) => {
          return (
            <Proposal as={Link} to={'/vote/' + p.id} key={i}>
              <ProposalNumber>{p.id}</ProposalNumber>
              <ProposalTitle>{p.title}</ProposalTitle>
              <ProposalStatus status={p.status}>{p.status}</ProposalStatus>
            </Proposal>
          )
        })}
      </TopSection>
      <TYPE.subHeader color="text3">
        A minimum threshhold of 1% of the total DEER supply is required to submit proposals
      </TYPE.subHeader>
    </PageWrapper>
  )
}
